import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import axios from 'axios';
import { routerPaths } from '@/routers/router-paths';

export function useAxiosInterceptor() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      res => res,
      err => {
        if (axios.isAxiosError(err) && err.response?.status === 401) {
          console.log('401 error detected:', err);

          if (location.pathname !== routerPaths.login) {
            console.log('Redirecting to login page');
            navigate(routerPaths.login, { replace: true });
          } else {
            console.log('Already on login page, not redirecting');
          }
        }
        return Promise.reject(err);
      },
    );

    // Cleanup function to remove interceptor
    return () => {
      console.log('Removing axios interceptor');
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate, location]);
}
